// Shared guard for the lightweight data indexes (cities-index.js, services-index.js).
// Returns the list of mismatches; in development it also warns in the console.
// The production build runs the same comparison in scripts/prerender-entry.jsx and
// FAILS when the lists disagree, so an index can never silently drift.

export const indexMismatches = (index, full, keys) => {
  const problems = [];
  if (index.length !== full.length) problems.push(`count differs: index ${index.length} vs full ${full.length}`);
  const bySlug = new Map(full.map((x) => [x.slug, x]));
  for (const item of index) {
    const src = bySlug.get(item.slug);
    if (!src) {
      problems.push(`index has "${item.slug}" which the full data lacks`);
      continue;
    }
    for (const k of keys) if (item[k] !== src[k]) problems.push(`"${item.slug}".${k}: index ${JSON.stringify(item[k])} vs full ${JSON.stringify(src[k])}`);
  }
  const indexed = new Set(index.map((x) => x.slug));
  for (const x of full) if (!indexed.has(x.slug)) problems.push(`full data has "${x.slug}" missing from the index`);
  return problems;
};

export const assertIndexInSync = (label, index, full, keys) => {
  if (process.env.NODE_ENV === "production") return; // the build-time check in prerender-entry.jsx covers production
  const problems = indexMismatches(index, full, keys);
  if (problems.length) {
    console.warn(`[data] ${label} is out of sync with the full data:\n - ${problems.join("\n - ")}`);
  }
};
